import React from "react";
import { Link } from "react-router-dom";
import Header from "@/sections/Header";
import Footer from "@/sections/Footer";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, eyebrow, lastUpdated, children }) {
  return (
    <>
      <Header />
      <main className="relative pt-32 md:pt-40 pb-24 min-h-screen">
        {/* Subtle ambient glow */}
        <div
          className="mk-orb"
          style={{ width: 460, height: 460, background: "#0A66FF", top: -100, left: -120, opacity: 0.25 }}
          aria-hidden
        />

        <div className="relative max-w-3xl mx-auto px-6 lg:px-8">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-white transition-colors mb-10"
            data-testid="legal-back-link"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to home
          </Link>

          <span className="text-[11px] uppercase tracking-[0.22em] text-[#00D4FF] font-medium">
            {eyebrow}
          </span>
          <h1 className="mt-4 font-display text-4xl md:text-5xl tracking-tight text-white">
            {title}
          </h1>
          {lastUpdated && (
            <p className="mt-4 text-sm text-slate-500">Last updated: {lastUpdated}</p>
          )}

          <div className="mt-12 mk-legal-prose space-y-6">{children}</div>
        </div>
      </main>
      <Footer />
    </>
  );
}
